import { clearNativeVoiceAttempt, createNativeVoiceAttempt, getNativeVoiceActorId, loadNativeVoiceAttempt } from './nativeVoiceAttempt';
export { getNativeVoiceActorId as getBrowserVoiceActorId, loadNativeVoiceAttempt as loadBrowserVoiceAttempt };
async function withAttemptLock(actorId, operation) {
    const locks = typeof navigator === 'undefined' ? undefined
        : navigator.locks;
    if (!locks || typeof locks.request !== 'function') {
        throw new Error('This browser cannot safely coordinate phone recovery. Open the calling app in a supported browser.');
    }
    // Only storage reservation/removal is locked; a provider wait must not hold another tab open.
    return locks.request(`malka-phone-attempt:${actorId}`, { ifAvailable: true }, async (lock) => {
        if (!lock)
            throw new Error('Another tab is updating phone recovery. Try again.');
        if (getNativeVoiceActorId() !== actorId)
            throw new Error('Sign in as the original interpreter to recover this phone attempt.');
        return operation();
    });
}
export async function reserveBrowserVoiceAttempt(platformCallId, sessionId, actorId) {
    return withAttemptLock(actorId, async () => {
        const previous = await loadNativeVoiceAttempt();
        if (previous)
            return { attempt: previous, created: false };
        return { attempt: await createNativeVoiceAttempt(platformCallId, sessionId, actorId), created: true };
    });
}
export async function clearBrowserVoiceAttempt(attempt) {
    await withAttemptLock(attempt.actorId, () => clearNativeVoiceAttempt(attempt));
}
export async function ownsBrowserVoiceAttempt(attempt) {
    const current = await loadNativeVoiceAttempt();
    return current?.attemptId === attempt.attemptId && current.actorId === attempt.actorId
        && current.platformCallId === attempt.platformCallId && current.sessionId === attempt.sessionId;
}
